import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.whitePepper.main,
    padding: '20px 25px 60px',

    [theme.breakpoints.up('sm')]: {
      padding: '20px 50px 85px',
    },
  },

  title: {
    padding: '55px 0 70px',
    [theme.breakpoints.up(768)]: {
      padding: '40px 0 50px',
    },
  },

  container: {
    display: 'flex',
    justifyContent: 'center',
  },

  itemWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1 , 1fr)',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    justifyContent: 'center',
    columnGap: '80px',
    rowGap: '75px',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2 , 1fr)',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(3 , 1fr)',
    },
  },

  item: {
    maxWidth: '320px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  imgWrapper: {
    position: 'relative',
    width: '250px',
    height: '110px',
    margin: '15px 0 20px',
  },
});
